import { Box, Button, Divider, FormLabel, Grid, IconButton, Input, Modal, SelectChangeEvent, Stack, Switch, Typography } from "@mui/material";
import { SelectMinisterio } from "../../../../components/selects/ministerio";
import { SelectSede } from "../../../../components/selects/sede";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ServicesCadastrar as useServices } from "./services";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import InputCep from "../../../../components/inputs/cepInput";
import { SelectCelula } from "../../../../components/selects/celula";

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 2,
};

export default function AddEvento() {

  const {
    cadastrarCelula,
    celula,
    valuesExtras,
    changeCampusCelula,
    isError
  } = useServices();

  const router = useNavigate();

  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    router(-1);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography id="modal-modal-title" variant="h5" component="h2">
              Evento
            </Typography>
            <IconButton aria-label="fechar" size="medium" onClick={handleClose}>
              <CloseRoundedIcon fontSize="inherit" />
            </IconButton>
          </div>
          <Divider />
          <Grid display={'grid'} gap={'8px'} mt={1} gridTemplateColumns={{ lg: 'repeat(2, 1fr)' }}>
            <Grid item display={'grid'}>
              <SelectSede
                value={valuesExtras?.sede || ''}
                action={(value) => { changeCampusCelula('sede', value); }}
              />
            </Grid>

            <SelectMinisterio
              idsede={valuesExtras?.sede || ''}
              valor={valuesExtras?.ministerio}
              action={(value: SelectChangeEvent) => { changeCampusCelula('ministerio', value?.target?.value); }}
            />


            <SelectCelula
              idministerio={valuesExtras?.ministerio || ''}
              valor={celula?.celula}
              action={(value: SelectChangeEvent) => { changeCampusCelula('celula', value?.target?.value); }}
            />

            <Grid item display={'grid'}>
              <FormLabel>Nome</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('descricao', String(value?.target?.value))}
                value={celula?.descricao || ''}
              />
              {
                isError?.descricao && (
                  <p>{isError?.descricao}</p>
                )
              }
            </Grid>

            <Grid item display={'grid'}>
              <InputCep
                onChange={(value) => changeCampusCelula('cep', value)}
                value={celula?.cep}
              />
               {
                isError?.cep && (
                  <p>{isError?.cep}</p>
                )
              }
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>Bairro</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('bairro', String(value?.target?.value))}
                value={celula?.bairro || ''}
              />
                {
                isError?.bairro && (
                  <p>{isError?.bairro}</p>
                )
              }
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>Rua</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('rua', value?.target?.value)}
                value={celula?.rua || ''}
              />
                {
                isError?.rua && (
                  <p>{isError?.rua}</p>
                )
              }
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Início</FormLabel>
              <Input
                type="datetime-local"
                onChange={(value) => changeCampusCelula('inicio', value?.target?.value)}
                value={celula?.inicio || ''}
              />
                {
                isError?.inicio && (
                  <p>{isError?.inicio}</p>
                )
              }
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Fim</FormLabel>
              <Input
                type="datetime-local"
                onChange={(value) => changeCampusCelula('fim', value?.target?.value)}
                value={celula?.fim || ''}
              />
                {
                isError?.fim && (
                  <p>{isError?.fim}</p>
                )
              }
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Ativo</FormLabel>
              <Switch
                onChange={() => changeCampusCelula('ativo', !celula?.ativo)}
                value={celula?.ativo || ''}
              />
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Permite Inscrição</FormLabel>
              <Switch
                onChange={() => changeCampusCelula('inscricao', !celula?.inscricao)}
                value={celula?.ativo || ''}
              />
            </Grid>

          </Grid>
          <Stack mt={2} direction={'row'} justifyContent={'space-between'}>
            <Button color="error">Cancelar</Button>
            <Button onClick={cadastrarCelula}>Criar</Button>
          </Stack>
        </Box>
      </Modal>
    </>
  )
}
